import type { LoaderFunctionArgs } from 'react-router';

import type { QueryClient } from '@tanstack/react-query';

import { enterpriseApi } from '@/common/enterprise-api';
import { createBlueprintDetailQuery } from '@/utilities/queries/create-blueprint-detail-query';

export const bluePrintDetailLoader = (queryClient: QueryClient) => {
  return ({ params: { blueprintPath } }: LoaderFunctionArgs) => {
    const id = Number.parseInt(blueprintPath ?? '-1', 10);

    return queryClient.ensureQueryData(createBlueprintDetailQuery(enterpriseApi, id));
  };
};
